import React from 'react';
import { RouteComponentProps } from 'react-router';
import styled from 'styled-components';
import ResetContent from './Components';

const Container = styled.div`
  height: 100vh;
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  background-color: white;
  z-index: 10;

  @media (min-width: 768px) and (max-width: 1024px) {
    top: auto;
    position: initial;
    height: auto;
    padding-bottom: 30px;
  }

  @media (max-width: 767px) {
    position: initial;
    height: auto;
    padding-bottom: 30px;
  }
`;

export const BackgroundHeader = styled.div`
  height: 153px;
  background: white;
  position: absolute;
  right: 0;
  top: -78px;
  left: 0;
`;

export const BackgroundFooter = styled.div`
  max-height: 512px;
  height: 100%;
  background: white;
  position: absolute;
  right: 0;
  left: 0;

  @media (min-width: 1025px) {
    display: none;
  }

  @media (min-width: 760px) and (max-width: 1024px) {
    max-height: 900px;
    display: block;
  }

  @media (max-width: 759px) {
    display: block;
    max-height: 512px;
  }
`;

interface props extends RouteComponentProps {}

function ResetPage({ history, location }: props){
  interface IState {
    state: {
      unverified?: boolean;
    };
  }
  const { state } = location as IState;
  return (
    <Container>
      <BackgroundHeader />
      <ResetContent />
      <BackgroundFooter />
    </Container>
  );
};

export default ResetPage;
